import { Grid, TableContainer, Table, TableBody, TableCell, TableHead, TableRow, Paper } from "@material-ui/core";
import React, { useEffect } from "react";
import LoadingOverlay from 'react-loading-overlay';
import ReactLoading from 'react-loading';
import ExportButton from "utils/CustomButtons/ExportToCVSButton";
import { CallAPI } from "services/API";

const useMediaQuery = (query) => {
    const mediaMatch = window.matchMedia(query);
    const [matches, setMatches] = React.useState(mediaMatch.matches);

    useEffect(() => {
        const handler = e => setMatches(e.matches);
        mediaMatch.addEventListener("change", handler);
        return () => mediaMatch.removeEventListener("change", handler);
    });
    return matches;
};

export default function OnlineBinds_PIP(props) {
    const isMobile = useMediaQuery('(max-width: 1152px)');
    const integer = new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });

    const [dataPIP1To3, setDataPIP1To3] = React.useState([]);
    const [loadingPIP1To3, setLoadingPIP1To3] = React.useState(false);
    const [dataPIP4To6, setDataPIP4To6] = React.useState([]);
    const [loadingPIP4To6, setLoadingPIP4To6] = React.useState(false);

    const GetDataPIP1To3 = async () => {
        const response = await CallAPI("POST", "/OnlineBinds/GetPIP1To3", {
            startDate: props.startDate,
            endDate: props.endDate,
            states: props.states,
            city: props.city
        });

        if (response)
            setDataPIP1To3([{
                case: "CRC",
                p1: integer.format(response.crcUnlimitedPIP),
                p2: integer.format(response.crC500kPIP),
                p3: integer.format(response.crC250kPIPNoExclusions),
            }, {
                case: "Agency",
                p1: integer.format(response.agencyUnlimitedPIP),
                p2: integer.format(response.agency500kPIP),
                p3: integer.format(response.agency250kPIPNoExclusions),
            }, {
                case: "Combo",
                p1: integer.format(response.comboUnlimitedPIP),
                p2: integer.format(response.combo500kPIP),
                p3: integer.format(response.combo250kPIPNoExclusions),
            }, {
                case: "Online",
                p1: integer.format(response.onlineUnlimitedPIP),
                p2: integer.format(response.online500kPIP),
                p3: integer.format(response.online250kPIPNoExclusions),
            }]);
        
        setLoadingPIP1To3(false);
    };
    
    const GetDataPIP4To6 = async () => {
        const response = await CallAPI("POST", "/OnlineBinds/GetPIP4To6", {
            startDate: props.startDate,
            endDate: props.endDate,
            states: props.states,
            city: props.city
        });
        
        if (response)
            setDataPIP4To6([{
                case: "CRC",
                p4: integer.format(response.crC250kPIPSomeExclusions),
                p5: integer.format(response.crC50kPIP),
                p6: integer.format(response.crcNoPIPMedical),
            }, {
                case: "Agency",
                p4: integer.format(response.agency250kPIPSomeExclusions),
                p5: integer.format(response.agency50kPIP),
                p6: integer.format(response.agencyNoPIPMedical),
            }, {
                case: "Combo",
                p4: integer.format(response.combo250kPIPSomeExclusions),
                p5: integer.format(response.combo50kPIP),
                p6: integer.format(response.comboNoPIPMedical),
            }, {
                case: "Online",
                p4: integer.format(response.online250kPIPSomeExclusions),
                p5: integer.format(response.online50kPIP),
                p6: integer.format(response.onlineNoPIPMedical),
            }]);
        
        setLoadingPIP4To6(false);
    };

    useEffect(() => {
        if (props.call === "true" || props.call === null) {
            GetDataPIP1To3();
            setLoadingPIP1To3(true);
            GetDataPIP4To6();
            setLoadingPIP4To6(true);
        }
    }, [props.call]);

    return (
        <Grid container> {/* Quotes Table */}
            <Grid item lg={12} xs={12}>
                    <Grid container>
                        <Grid item
                            style={
                                isMobile ?
                                    {
                                        margin: "0em",
                                        padding:"1em",
                                        paddingRight:"1em",
                                        width: "100%",
                                        paddingTop: "1em",
                                        backgroundColor: "#f1f1f1",
                                        fontSize: "1.3em",
                                        position: "relative",
                                        textAlign: "center"
                                    }
                                    :
                                    {
                                        backgroundColor: "#f1f1f1",
                                        width: "60%",
                                        margin: "1em auto", 
                                        padding: "1em",
                                        fontSize: "2.5em",
                                        position: "relative",
                                        textAlign: "center"
                                    }
                            }
                        >
                            <span

                            >
                                <span
                                    style={{
                                        fontWeight: "bold",
                                        color: "#1d4c80"
                                    }}
                                >
                                ONLINE BINDS
                                </span>
                        </span>
                        <br />
                        <br />
                        <span
                            style={{ fontSize: ".7em", marginTop: "1em" }}
                        >
                            <span
                                style={{
                                    fontWeight: "bold",
                                    color: "#1d4c80"
                                }}
                            >
                                PIP 1-3 
                            </span>
                        </span>
                        <LoadingOverlay
                            active={loadingPIP1To3}
                            styles={{
                                overlay: (base) => ({
                                    ...base,
                                    position: "absolute!important"
                                })
                            }}
                            spinner={<ReactLoading type={'spin'} height={50} width={50} />}
                        >
                            <OnlineBinds_P1P2P3
                                data={dataPIP1To3}
                            />
                        </LoadingOverlay>
                        <ExportButton
                            ExportName="PIP_1_3"
                        />
                            
                        <br />
                        <br />
                        <span
                            style={{ fontSize: ".7em", marginTop: "1em" }}
                        >
                            <span
                                style={{
                                    fontWeight: "bold",
                                    color: "#1d4c80"
                                }}
                            >
                                PIP 4-6 
                            </span>
                        </span>
                        
                        <LoadingOverlay
                            active={loadingPIP4To6}
                            styles={{
                                overlay: (base) => ({
                                    ...base,
                                    position: "absolute!important"
                                })
                            }}
                            spinner={<ReactLoading type={'spin'} height={50} width={50} />}
                        >
                            <OnlineBinds_P4P5P6
                                data={dataPIP4To6}
                        />
                        </LoadingOverlay>
                        <ExportButton
                            ExportName="PIP 4-6"
                        />
                        </Grid>
                    </Grid>
            </Grid>
        </Grid>
    );
}


const OnlineBinds_P1P2P3 = (qprops) => {
    return (
            <Paper>
            <TableContainer style={{ position: "relative", marginTop: "1em", maxHeight: "400px"}}>
                <Table stickyHeader sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="left" style={{ fontSize: "14px", minWidth: "70px", maxWidth: "70px" }}></TableCell>
                            <TableCell align="left" style={{ fontSize: "14px", minWidth: "120px", maxWidth: "120px" }}>Unlimited PIP</TableCell>
                            <TableCell align="left" style={{ fontSize: "14px", minWidth: "120px", maxWidth: "120px" }}>$500K PIP</TableCell>
                            <TableCell align="left" style={{ fontSize: "14px", minWidth: "120px", maxWidth: "120px" }}>$250K PIP-No Exclusions</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {(qprops.data == null || qprops.data.length === 0) && ["CRC", "Combo", "Online"].map((title, index) => (
                            <TableRow key={index}>
                                <TableCell align="left" style={{ fontWeight: "bold" }}>{title}</TableCell>
                                {[...Array(3)].map((_, cellIndex) => (
                                    <TableCell key={cellIndex} align="left"></TableCell>
                                ))}
                            </TableRow>
                        ))}
                        {qprops.data != null && qprops.data.map((item, index) => (
                            <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell align="left" style={{ fontWeight: "bold" }}>{item.case}</TableCell>
                                <TableCell align="left">{item.p1}</TableCell>
                                <TableCell align="left">{item.p2}</TableCell>
                                <TableCell align="left">{item.p3}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            </Paper>
        );
}

const OnlineBinds_P4P5P6 = (qprops) => {
    return (
        <Paper>
            <TableContainer style={{ position: "relative", marginTop: "1em", maxHeight: "400px" }}>
                <Table stickyHeader sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="left" style={{ fontSize: "14px", minWidth: "70px" , maxWidth: "70px"  }}></TableCell>
                            <TableCell align="left" style={{ fontSize: "14px", minWidth: "120px", maxWidth: "120px" }}>$250K PIP- Some Exclusions</TableCell>
                            <TableCell align="left" style={{ fontSize: "14px", minWidth: "120px", maxWidth: "120px" }}>$50K PIP</TableCell>
                            <TableCell align="left" style={{ fontSize: "14px", minWidth: "120px", maxWidth: "120px" }}>No PIP Medical</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(qprops.data == null || qprops.data.length === 0) && ["CRC", "Combo", "Online"].map((title, index) => (
                            <TableRow key={index}>
                                <TableCell align="left" style={{ fontWeight: "bold" }}>{title}</TableCell>
                                {[...Array(3)].map((_, cellIndex) => (
                                    <TableCell key={cellIndex} align="left"></TableCell>
                                ))}
                            </TableRow>
                        ))}
                        {qprops.data != null && qprops.data.map((item, index) => (
                            <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell align="left" style={{ fontWeight: "bold" }}>{item.case}</TableCell>
                                <TableCell align="left">{item.p4}</TableCell>
                                <TableCell align="left">{item.p5}</TableCell>
                                <TableCell align="left">{item.p6}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
}

export const formatWhole = (num) => {
    if (isNaN(num) || num === undefined) { return "" }
    return new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(Math.abs(num))
}

